import * as Logger from "../backend/TelemetryLogger/Details/Logger";
import { LogEventNames } from "../backend/interfaces/ITelemetryLogger";
import { FileUploadForegroundTaskError, FileUploadForegroundTaskErrors } from '../backend/common/fileUpload/FileUploadForegroundTaskErrors';
import { BootError, BootErrors } from "../frontend/BootErrors";
import { AudioBackupError, AudioBackupErrors } from "../backend/audioBackup/AudioBackupErrors";
import { ErrorStringFromException } from "../utils/utils";
import { OneDriveUploadTaskError, OneDriveUploadTaskErrors } from "../backend/oneDrive/OneDriveUploadTaskErrors";
import { AuthErrors } from "../backend/office-js/auth/AuthErrors";

/**
 * Main telemetry logging API for Errors
  * @param area Event area that error occured in
  * @param message Error string to be logged
 */
export function LogError(area: LogEventNames, message: string) {
    Logger.LogError({ area, message });
}

export function LogErrorAndThrow(area: LogEventNames, error: any) {
    LogError(area, ErrorStringFromException(error));
    throw error;
}

// If this returns true, we should log the error as warning
// so it does not affect our error metrics.
export function ShouldLogErrorAsWarning(error: Error | any) {
    // Track unsupported file format as a warning.
    if (error instanceof FileUploadForegroundTaskError && error.name == FileUploadForegroundTaskErrors.UnsupportedFileFormat)
       return true;

    if (error instanceof FileUploadForegroundTaskError && error.name == FileUploadForegroundTaskErrors.InvalidFileNameForOneDriveFileUpload)
       return true;

    if (error instanceof FileUploadForegroundTaskError && error.name == FileUploadForegroundTaskErrors.OneDriveUploadCanceled)
       return true;

    if (error instanceof FileUploadForegroundTaskError && error.name == FileUploadForegroundTaskErrors.FileExceedsSizeLimit)
        return true;

    if (error instanceof FileUploadForegroundTaskError && error.name == FileUploadForegroundTaskErrors.InvalidEmptyFile)
        return true;

    if (error instanceof FileUploadForegroundTaskError && error.name == FileUploadForegroundTaskErrors.FileDecodeError)
        return true;

    if (error instanceof FileUploadForegroundTaskError && error.name == FileUploadForegroundTaskErrors.FileNotExist)
        return true;

    if (error instanceof FileUploadForegroundTaskError && error.name == FileUploadForegroundTaskErrors.DeletedTranscript)
        return true;

    if (error instanceof OneDriveUploadTaskError && error.name == OneDriveUploadTaskErrors.OneDriveQuotaLimitReached)
        return true;

    if (error instanceof BootError && error.name == BootErrors.IndexeddbFailedToOpen)
        return true;

    if (typeof error !== "undefined" && typeof error.code !== "undefined" && (error.code == AuthErrors.CannotGetAuthContext)) {
      return true;
    }

    if (error instanceof AudioBackupError && (error.name == AudioBackupErrors.UnsupportedBrowser || error.name == AudioBackupErrors.IndexedDBOpenError))
        return true;

    return false;
}
